import React from 'react'
import Container from '../components/Container'
import { ScrollFadeIn } from '../../../components/ScrollFadeIn'

const Mission = () => {
  return (
    <Container bgColor='bg-primary-800'>
      <ScrollFadeIn className=" ">
        <div className="hidden sm:block">
          <h1 className="text-white text-center heading-1" aria-label="We're on a Mission to Change the Financial Planning Industry">
            We're on a Mission to Change the
          </h1>
          <h1 className="text-white text-center heading-1">
            Financial Planning Industry.
          </h1>
        </div>
        <div className="sm:hidden">
          <h1 className="text-white text-center mx-auto heading-1" aria-label="We're on a Mission to Change the Financial Planning Industry">
            We're on a Mission to Change the Financial Planning Industry.
          </h1>
        </div>
      </ScrollFadeIn>
    </Container>
  )
}

export default Mission